module.exports = {"newsletter":{"title":"订阅每周最新 JS 排名","text":"在下面订阅 {link} 周刊，就能每周收到最新最流行的 JavaScript 项目发展趋势独家报告","button":"订   阅","placeholder":"您的邮箱"},"view_project":{"twitter":{"text":"在 {year} 年, {name} 增加了 {delta} 个 star, 在 GitHub {category} 分类中排名第 {ranking}。","action":"Tweet"},"months":"1月 2月 3月 4月 5月 6月 7月 8月 9月 10月 11月 12月","created":"创建于","homepage":"项目主页"}}


//////////////////
// WEBPACK FOOTER
// ./i18n/common/zh.yaml
// module id = 454
// module chunks = 230186691558513